export const TEXT_SETTINGS_TITLE = 'TEXT SETTINGS'
export const TEXT_SETTINGS_MORE = {
    arc: {
        label: "Arc",
        max: 360,
        min: 0
    },
    rotate: {
        label: "Rotate",
        max: 360,
        min: 0
    },
    size: {
        label: "Size",
        max: 360,
        min: 0
    },
    spacing: {
        label: "Spacing",
        max: 360,
        min: 0
    }
};
export const TEXT_SETTINGS_OUTLINE = {
    weight: {
        label: "Weight",
        max: 360,
        min: 0
    }
};